import React from 'react';
import _ from 'underscore';

import { imgPath } from '../../../common/utilities/ImgUrl';
import { IServerUserInfo } from '../../../ts/models/IServerUserInfo';
import { ISiteUserInfo } from '../../../ts/models/ISiteUserInfo';
import { IToastOptions, ToasterService, ToastType } from '../../../ts/services/ToasterService';
import { ProfilePictureService } from '../../../userSettings/services/ProfilePictureService';
import { EditableUserProfilePicture } from '../../content/EditableUserProfilePicture';

export interface SiteUserIconProps {
  readonly user: IServerUserInfo | ISiteUserInfo;
  readonly isSessionUserSelf: boolean;
}

export class SiteUserIconComponent extends React.Component<SiteUserIconProps> {
  public render() {
    let imgSrc = imgPath('user_content_type.svg');
    if (_.has(this.props.user, 'userImageUrl') && this.props.user.userImageUrl) {
      imgSrc = this.props.user.userImageUrl;
    }
    const props: EditableUserProfilePicture.Props = {
      profileDisplayName: this.props.user.displayName,
      imageUrl: imgSrc,
      allowEdit: this.props.isSessionUserSelf,
      imageValidator: this.imageValidator,
      handleSubmit: this.handleSubmit
    };

    return <EditableUserProfilePicture {...props} />;
  }

  private imageValidator = (imageFile: File, handleValidationResult: (isValidImage: boolean) => void) => {
    const errorMessage: string = ProfilePictureService.validateImage(imageFile);
    if (errorMessage) {
      this.showToasterWarningOrReload ({
        type: ToastType.Error,
        text: errorMessage,
      });
    }
    handleValidationResult(!errorMessage);
  }

  private handleSubmit =  (newUserImage: Blob) => {
    ProfilePictureService.handlePictureSubmit(this.props.user.domainName, this.props.user.username,
      newUserImage, (toasterConfig: IToastOptions) => this.showToasterWarningOrReload(toasterConfig));
  }

  private showToasterWarningOrReload = (toasterConfig: IToastOptions) => {
    if (toasterConfig) {
      ToasterService.instance.pop(toasterConfig);
    } else {
      window.location.reload();
    }
  }
}


export const SiteUserIcon: React.ComponentType<SiteUserIconProps> = SiteUserIconComponent;
